<template>
  <div class="dept-page tree-line-style section-main__warp">
    <!-- 部门 -->
    <div class="dept-left">
      <div class="area-title">部门信息</div>
      <div class="area-search">
        <el-input
          placeholder="请输入搜索关键字"
          prefix-icon="el-icon-search"
          v-model="searchString"
          clearable
        >
        </el-input>
      </div>
      <el-scrollbar class="scroll-bar">
        <el-tree
          ref="tree"
          class="tree-content"
          :data="treeData"
          node-key="id"
          :default-expanded-keys="expandedKeys"
          default-expand-all
          :props="treeProps"
          :highlight-current="true"
          :filter-node-method="filterNode"
          @node-click="nodeClick"
        >
          <template slot-scope="{ node, data }">
            <element-tree-line
              :node="node"
              :showLabelLine="true"
              :indent="16"
              class="tree-line"
            >
              <span class="custom-tree-node">
                <span class="tree-label" :title="node.label"> {{ node.label }}</span>
                <div class="area-operator" v-if="data.parentCode == -1">
                  <!-- 根节点 -->
                  <el-button
                    type="text"
                    class="el-icon-plus"
                    size="medium"
                    @click.stop="() => handleAdd(data)"
                  ></el-button>
                  <el-button
                    type="text"
                    class="el-icon-edit-outline"
                    size="medium"
                    @click.stop="() => handleEdit(node, data)"
                  ></el-button>
                </div>
                <div
                  class="area-operator"
                  v-if="checkNode.id === data.id && data.parentCode != -1"
                >
                  <!-- 字节点 -->
                  <el-button
                    type="text"
                    class="el-icon-plus"
                    size="medium"
                    @click.stop="() => handleAdd(data)"
                  ></el-button>

                  <el-button
                    type="text"
                    class="el-icon-edit-outline"
                    size="medium"
                    @click.stop="() => handleEdit(node, data)"
                  ></el-button>
                  <el-button
                    type="text"
                    class="el-icon-delete-solid"
                    size="medium"
                    @click.stop="() => handleDelete(node, data)"
                  ></el-button>
                </div>
              </span>
            </element-tree-line>
          </template>
        </el-tree>
      </el-scrollbar>
    </div>

    <!-- 岗位 -->
    <div class="dept-right">
      <ioc-table
        ref="crud"
        :data="tableData"
        :option="tableOption"
        :page="page"
        @search-change="handleSearchChange"
        @search-reset="handleSearchReset"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @selection-change="handleSelectChange"
      >
        <template slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" @click="handleAddPost"
            >新增</el-button
          >
          <el-button type="primary" icon="el-icon-delete" @click="handleBatchDeletePost"
            >批量删除</el-button
          >
        </template>
        <template slot="menu" slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('emergencyHandle.button.edit')"
            placement="top-start"
          >
            <el-button
              type="text"
              icon="iconfont icon-xiugai pointer"
              @click="() => handleEditPost(scope.row)"
            ></el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('emergencyHandle.button.delete')"
            placement="top"
            popper-class="tooltip-draw"
          >
            <el-button
              type="text"
              icon="el-icon-delete pointer"
              @click="() => handleDeletePost([scope.row.deptCode])"
            >
            </el-button>
          </el-tooltip>
        </template>
      </ioc-table>
    </div>
    <el-dialog
      v-ops:width="450"
      :close-on-click-modal="false"
      :title="pageType == 'add' ? '新增部门信息' : '编辑部门信息'"
      :visible.sync="showDeptDialog"
    >
      <el-form ref="deptFormRef" :rules="rules" :model="deptForm" label-width="85px">
        <el-form-item label="上级部门" v-if="deptForm.parentCode != -1" prop="parentName">
          <el-input type="text" disabled v-model="deptForm.parentName"></el-input>
        </el-form-item>
        <el-form-item label="部门名称" prop="name">
          <el-input
            type="text"
            maxlength="30"
            placeholder="请输入部门名称"
            v-model="deptForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门领导" prop="leaderPersonnelName">
          <el-input
            readonly
            placeholder="请选择部门领导"
            v-model="deptForm.leaderPersonnelName"
          ></el-input>
          <img
            style="cursor: pointer; position: absolute; top: 10px; right: 10px"
            src="@src/common/assets/images/icon/more.png"
            @click="queryPersonType"
            alt=""
          />
        </el-form-item>
        <el-form-item label="备注" prop="desc">
          <el-input
            type="text"
            maxlength="30"
            placeholder="请输入备注"
            v-model="deptForm.desc"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancelForm">{{
          $t("cameraList.button.cancel")
        }}</el-button>
        <el-button type="primary" @click="handleSaveForm">{{
          $t("cameraList.button.conform")
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-ops:width="450"
      :close-on-click-modal="false"
      :title="postType == 'add' ? '新增岗位信息' : '编辑岗位信息'"
      :visible.sync="showPostDialog"
    >
      <el-form ref="postFormRef" :rules="rules" :model="postForm" label-width="85px">
        <el-form-item label="岗位名称" prop="name">
          <el-input
            type="text"
            maxlength="30"
            placeholder="请输入岗位名称"
            v-model="postForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属部门" prop="deptCode">
          <el-cascader
            :disabled="postType == 'edit'"
            v-model="postForm.deptCode"
            :options="treeData"
            placeholder="请选择所属部门"
            style="width: 100%"
            :show-all-levels="false"
            :props="cascaderProps"
            @change="cascaderChange"
          >
            <template slot-scope="{ node, data }">
              <span>{{ data.name }}</span>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item label="备注" prop="desc">
          <el-input
            type="text"
            maxlength="30"
            placeholder="请输入备注"
            v-model="postForm.desc"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancelPostForm"> 取消</el-button>
        <el-button type="primary" @click="handleSavePostForm">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="人员列表"
      v-dialogDrag
      :visible.sync="showPerson"
      :before-close="closePerson"
      @close="closePerson"
      class="choose-container"
      width="63%"
    >
      <ioc-table
        :data="tableList"
        :option="tablePeopleOption"
        :page="pagePeople"
        ref="iocTable"
        @search-change="handleSearchChangePeople"
        @search-reset="handleSearchResetPeople"
        @size-change="handleSizeChangePeople"
        @current-change="handleCurrentChangePeople"
        @refresh-change="refreshChangePeople"
        @radio-change="handleSelectionChangePeople"
      ></ioc-table>
      <div slot="footer" class="dialog-footer tc" style="text-align: right">
        <el-button @click="closePerson" type="info">{{
          $t("area.button.cancel")
        }}</el-button>
        <el-button type="primary" @click="submitPerson">{{
          $t("area.button.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import tableOption from "../const/table";
import ElementTreeLine from "element-tree-line";
import utils from "$utils";
import { api } from "../api";
export default {
  components: {
    ElementTreeLine,
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    return {
      tablePeopleOption: {
        radio: true,
        index: true,
        column: [
          {
            label: this.$t("area.label.workNo"),
            prop: "workNo",
            search: true,
            clearable: true,
          },
          {
            label: this.$t("area.label.personnelName"),
            // search: true,
            prop: "name",
            search: true,
            clearable: true,
          },
          {
            label: this.$t("area.label.sex"),
            prop: "sex",
            formatter: (row, value) => {
              if (Number(value) === 1) {
                return "男";
              } else if (value === null) {
                return "";
              } else if (Number(value) === 0) {
                return "女";
              }
            },
          },
          {
            label: this.$t("area.label.phone"),
            search: true,
            clearable: true,
            prop: "phone",
          },
          {
            label: this.$t("area.label.departmentName"),
            prop: "departmentName",
          },
          {
            label: this.$t("area.label.position"),
            prop: "positionName",
            search: true,
            clearable: true,
          },
        ],
      },
      cascaderProps: {
        children: "children",
        label: "name",
        value: "id",
        checkStrictly: true,
        expandTrigger: "hover",
      },
      showPostDialog: false,
      checkNode: {},
      checkTable: [],
      pageType: "",
      postType: "add",
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: ["blur", "change"],
          },
        ],
        deptCode: [
          {
            required: true,
            message: "请选择部门",
            trigger: ["blur", "change"],
          },
        ],
        leaderPersonnelName: [
          {
            required: true,
            message: "请选择部门领导人",
            trigger: ["blur", "change"],
          },
        ],
      },
      showDeptDialog: false,
      deptForm: {
        parentName: "",
        parentCode: "",
        name: "",
        desc: "",
        id: "",
        leaderPersonnelCode: "",
        leaderPersonnelName: "",
      },
      postForm: {
        deptCode: [],
        deptName: "",
        name: "",
        desc: "",
      },
      tableData: [],
      tableOption: tableOption(),
      isExpand: false,
      searchString: "",
      treeData: [],
      // 展开的节点id
      expandedKeys: [],
      treeProps: {
        children: "children",
        label: "name",
        id: "deptCode",
        isLeaf: "isLeaf",
      },
      showPanel: true,
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      pagePeople: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      searchParams: {},
      searchPeopleParams: {},
      btnLoading: false,
      showPerson: false,
      tableList: [],
      personList: [],
    };
  },

  created() {
    this.getDeptTree();
  },
  methods: {
    handleSelectionChangePeople(items) {
      console.log(items);
      this.personList = [];
      this.personList.push({
        personnelCode: items.personnelCode,
        personnelName: items.name,
      });
      console.log(this.personList);
    },
    submitPerson() {
      if (this.personList.length < 1) {
        this.$message.warning("请选择部门领导人");
        return;
      }
      this.deptForm.leaderPersonnelCode = this.personList[0].personnelCode;
      this.deptForm.leaderPersonnelName = this.personList[0].personnelName;
      this.closePerson();
    },
    closePerson() {
      this.personList = [];
      this.showPerson = false;
    },
    queryPerson() {
      this.showPerson = true;
      const params = {
        pageNum: this.pagePeople.currentPage,
        pageSize: this.pagePeople.pageSize,
        personnelType: 1,
        ...this.searchPeopleParams,
      };
      this.$fetch(api.queryPersonList, params).then((response) => {
        if (response.success) {
          this.tableList = response.returnObj.list;
          this.pagePeople.total = response.returnObj ? response.returnObj.total : 0;
          this.$refs.iocTable.templateRadio = "";
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    queryPersonType(type) {
      this.queryPerson();
    },
    cascaderChange(info) {
      console.log(info);
    },
    handleAddPost() {
      this.postType = "add";
      this.showPostDialog = true;
    },
    handleBatchDeletePost() {
      if (!this.checkTable.length) {
        this.$message.warning("请选择要删除的岗位");
        return;
      }
      this.handleDeletePost(
        this.checkTable.map((el) => {
          return el.deptCode;
        })
      );
    },
    handleEditPost(data) {
      console.log(data);
      this.postType = "edit";
      this.postForm.deptCode = data.parentCode;
      this.postForm.id = data.deptCode;
      this.postForm.name = data.deptName;
      this.postForm.desc = data.desc;
      this.showPostDialog = true;
    },
    handleDeletePost(arr) {
      this.$confirm("您确定删除该岗位信息吗", "删除确认", {
        confirmButtonText: this.$t("area.button.confirm"),
        cancelButtonText: this.$t("area.button.cancel"),
        type: "warning",
      })
        .then(() => {
          let params = {
            type: 2,
            deptCodeList: arr,
          };
          this.$fetch(api.deleteDept, params).then((response) => {
            if (response.success) {
              this.$message.success(response.msgContent || "操作成功");
              this.queryTable();
            } else {
              this.$message({
                type: "error",
                message: response.msgContent,
              });
            }
          });
        })
        .catch(() => {});
    },
    handleCancelPostForm() {
      this.$refs.postFormRef.resetFields();
      this.showPostDialog = false;
    },
    handleSavePostForm() {
      this.$refs.postFormRef.validate((valid) => {
        if (!valid) {
          return false;
        }
        let params = {
          deptName: this.postForm.name,
          parentCode: this.postForm.deptCode[this.postForm.deptCode.length - 1],
          desc: this.postForm.desc,
          type: 2,
        };
        let url = "";
        if (this.postType == "add") {
          url = api.addDeptTree;
        } else {
          url = api.updateDept;
          params.deptCode = this.postForm.id;
        }
        this.$fetch(url, params).then((res) => {
          if (!res.success) {
            this.$message.error(res.msgContent || "操作失败");
            return;
          }
          this.$message.success(res.msgContent || "操作成功");
          this.queryTable();
          this.handleCancelPostForm();
        });
      });
    },
    handleCancelForm() {
      this.$refs.deptFormRef.resetFields();
      this.showDeptDialog = false;
    },
    handleSaveForm() {
      console.log(this.deptForm);
      this.$refs.deptFormRef.validate((valid) => {
        if (!valid) {
          return false;
        }
        let params = {
          deptName: this.deptForm.name,
          desc: this.deptForm.desc,
          parentCode: this.deptForm.parentCode,
          type: 1,
          leaderPersonnelCode: this.deptForm.leaderPersonnelCode,
        };

        let url = "";
        if (this.pageType == "add") {
          url = api.addDeptTree;
        } else {
          url = api.updateDept;
          params.deptCode = this.deptForm.id;
        }
        this.$fetch(url, params).then((res) => {
          if (!res.success) {
            this.$message.error(res.msgContent || "操作失败");
            return;
          }
          this.$message.success(res.msgContent || "操作成功");
          this.getDeptTree();
          this.handleCancelForm();
        });
      });
    },
    handleAdd(data) {
      console.log(data);
      this.pageType = "add";
      this.deptForm.parentName = data.name;
      this.deptForm.parentCode = data.id;
      this.deptForm.leaderPersonnelCode = "";
      this.deptForm.leaderPersonnelName = "";
      this.deptForm.name = "";

      this.showDeptDialog = true;
    },
    handleEdit(node, data) {
      console.log(data);
      this.pageType = "edit";
      this.deptForm.parentName = data.parentName;
      this.deptForm.parentCode = data.parentCode;
      this.deptForm.leaderPersonnelCode = data.leaderPersonnelCode;
      this.deptForm.leaderPersonnelName = data.leaderPersonnelName;
      this.deptForm.name = data.name;
      this.deptForm.id = data.id;
      this.deptForm.desc = data.desc;
      this.showDeptDialog = true;
    },
    handleDelete(node, data) {
      this.$confirm("您确定删除该部门信息吗", "删除确认", {
        confirmButtonText: this.$t("area.button.confirm"),
        cancelButtonText: this.$t("area.button.cancel"),
        type: "warning",
      })
        .then(() => {
          let params = {
            deptCodeList: [data.id],
            type: 1,
          };
          this.$fetch(api.deleteDept, params).then((response) => {
            if (response.success) {
              this.$message.success(response.msgContent || "操作成功");
              this.getDeptTree();
            } else {
              this.$message({
                type: "error",
                message: response.msgContent,
              });
            }
          });
        })
        .catch(() => {});
    },
    handleSelectChange(el) {
      this.checkTable = [...el];
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.deptCode;
          entity.name = item.deptName;
          entity.desc = item.desc;
          entity.parentCode = item.parentCode;
          entity.parentName = item.parentName;
          entity.leaderPersonnelCode = item.leaderPersonnelCode;
          entity.leaderPersonnelName = item.leaderPersonnelName;
          entity.isLeaf = !item.hasLeaf || !item.children;
          if (item.children) {
            entity.children = self.menusDataPro(item.children);
          }
          result.push(entity);
        });
        return result;
      }
    },
    //获取区域列表
    getDeptTree() {
      const self = this;
      this.$fetch(api.queryDeptTree, { type: 1 }).then((response) => {
        const result = self.menusDataPro(response.returnObj);
        if (!response.returnObj.length) {
          return;
        }
        self.treeData = Object.freeze(result);
        self.nodeClick(self.treeData[0]);
        self.$nextTick(() => {
          self.$refs.tree.setCurrentKey(self.treeData[0]);
        });
      });
    },
    // 单击节点时
    nodeClick(data) {
      this.checkNode = { ...data };
      this.page.currentPage = 1;
      this.queryTable();
    },

    handleSearchResetPeople() {
      this.queryPerson();
    },
    refreshChangePeople() {
      this.queryPerson();
    },
    handleCurrentChangePeople(val) {
      this.pagePeople.currentPage = val;
      this.queryPerson();
    },
    handleSizeChangePeople(val) {
      this.pagePeople.currentPage = 1;
      this.pagePeople.pageSize = val;
      this.queryPerson();
    },
    handleSearchChangePeople(param) {
      this.pagePeople.currentPage = 1;
      this.searchPeopleParams = Object.assign(param);
      this.queryPerson();
    },

    handleSearchReset() {
      this.queryTable();
    },
    refreshChange() {
      this.queryTable();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.queryTable();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.queryTable();
    },
    handleSearchChange(param) {
      this.page.currentPage = 1;
      this.searchParams = Object.assign(param);
      this.queryTable();
    },
    queryTable() {
      const params = {
        pageBean: {
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
        },
        deptCode: this.checkNode.id,
        type: "2",
        cascadeFlag: "1",
        ...this.searchParams,
      };
      this.$fetch(api.queryDept, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.dept-page {
  // margin: 0 16px;
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 100vw;
  // flex: 1;

  .el-select {
    width: 100%;
  }

  .area-search {
    display: flex;
    margin: 10px 10px 20px;
    height: 28px;
    .el-input {
      width: 100%;
    }
  }

  .dept-left {
    margin: 0px 8px 0px 0px;
    max-height: 100%;
    overflow: hidden;
    width: 380px;
    border-radius: 5px 5px 0px 0px;
    @include set_theme_color(background-color, left-menu-bg-color);

    .area-title {
      margin: 10px 0 16px 10px;
      border-left: 5px solid #407aee;
      padding-left: 10px;
      font-size: 14px;
      // color: #e8eaee;
    }

    .scroll-bar {
      height: 100%;
      height: calc(100% - 100px);

      .el-scrollbar__wrap {
        .el-scrollbar__view {
          display: inline-block;
          min-width: 100%;
        }
      }
    }

    .tree-label {
      display: inline-block;
      width: 220px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .area-operator {
      display: inline-block;
      margin: 0 20px;

      .el-button {
        // color: #fff !important;
      }
    }
  }

  .dept-right {
    // flex: 1;
    width: calc(100vw - 520px);
    border-radius: 5px 5px 0px 0px;
  }
}

.tree-content {
  ::v-deep > .el-tree-node {
    min-width: 100%;
    display: inline-block;
  }
}
</style>
